<template>
  <div style="width: 70%">
    <b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></b-loading>
    <form>
      <b-field :message="{ 'Name cannot be blank': errorMapName }" :type="{ 'is-danger': errorMapName }"
               horizontal
               label="Find a map:">
        <b-autocomplete
            v-model="mapName"
            :data="filteredMapByNameAndDesc"
            :keep-first="true"
            :loading="isLoading"
            :open-on-focus="true"
            clearable
            field="name"
            placeholder="e.g. Bondi Beach"
            @select="option => previewMap(option)">

          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <img :src="props.option.imageUrl ? props.option.imageUrl : mapImage" width="32">
              </div>
              <div class="media-content">
                <b>{{ props.option.name }} -
                  {{ props.option.geolocationPoints ? props.option.geolocationPoints.length : 0 }} locations</b>
                <br>
                <small>{{ props.option.description }}</small>
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>
      <map-previewer v-if="isMapVisible" ref="map_previewer" :center="center" :mapType="mapType" :markers="markers"
                     height="400"></map-previewer>
    </form>
  </div>
</template>

<script>
import _ from 'lodash'
import MapPreviewer from '../single/MapPreviewer'
import mapService from '../../services/mapService'
import displayHelper from '../../helpers/display-helper'
import constantHelper from '@/enums/constants'

export default {
  components: {
    MapPreviewer,
  },
  props: {
    game: {},
    next: false,
    isEdit: false,
  },
  computed: {
    filteredMapByNameAndDesc() {
      return this.maps.filter((option) => {
        if ((option.name) && (option.description)) {
          return (option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(this.mapName.toLowerCase()) >= 0) ||
              (option.description
                  .toString()
                  .toLowerCase()
                  .indexOf(this.mapName.toLowerCase()) >= 0)
        }
      })
    }
  },
  data() {
    return {
      isLoading: false,
      maps: [],
      mapName: '',

      center: {lat: 1.3581036, lng: 103.8329625},
      markers: [],
      mapType: 'terrain',

      mapId: '',
      mapImage: '',

      isMapVisible: false,

      errorMapName: false,
    }
  },
  watch: {
    'next': function (next) {
      if (next) {
        if (!this.validateFields()) {
          console.log('Errors in fields')
          this.$emit('errors')
          return
        }

        if (this.game && this.game.map) {
          if (this.mapId !== this.game.map.id) {
            console.log('map changed -> pack needs to be changed as well')
          }
        }

        const step2Game = {
          map: {
            id: this.mapId,
            markers: this.markers,
            mapName: this.mapName,
          }
        }
        console.log('Before emit in Next Step 2')
        this.$emit('updated', step2Game)
      }
    }
  },
  created: function () {
    this.isLoading = true
    this.mapImage = constantHelper.GENERIC_MAP_PHOTO_URL

    this.loadMapsList()

    if (this.isEdit) {
      const map = this.game.map
      this.mapName = map.mapName
      this.mapId = map.id
      this.markers = map.markers

      this.isMapVisible = true
    } else {
      if (this.game) {
        if (this.game.map) {
          const map = this.game.map
          this.mapName = map.mapName ? map.mapName : ''
          this.mapId = map.id ? map.id : ''
          this.markers = map.markers ? map.markers : []

          this.isMapVisible = true
        }
      }
    }
  },
  methods: {
    loadMapsList() {
      var parent = this
      mapService.getFullMaps()
          .then(maps => {
            this.maps = maps
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
    },
    previewMap(option) {
      if (option) {
        this.markers = option.geolocationPoints.map(p => {
          let obj = _.pick(p, ['lat', 'lng'])

          obj.lat = parseFloat(obj.lat)
          obj.lng = parseFloat(obj.lng)

          return {position: obj}
        })
        this.mapId = option.mapId

        this.isMapVisible = true
      } else {
        this.isMapVisible = false
      }
    },
    validateFields() {
      let hasErrors = false
      if (!this.mapName) {
        this.errorMapName = true
        hasErrors = true
      }

      return !hasErrors
    }
  }
}
</script>
<style scoped>

</style>
